import "./personalDetails.css";
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import { CheckCircle as TickIcon, Search as SearchIcon, Cancel as CrossIcon, ArrowForwardIosSharp as AccordionIcon } from '@mui/icons-material';
import resolveIcon from "../../../../../images/resolved.png";
import { GET_ADDRESS_BY_IFSC, authKey, ResourceUpdateMember } from "../../../../../common/URLs";

import { Container, Card, CardContent, Divider, FormGroup, FormControlLabel, Switch, Checkbox, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { ROLES, BLOCK_LIST, CONSTANTS, EMPTY_FIELD_ERROR, LAND_AREA_UNIT, REVENUE_BLOCK_DEFAULT_VALUE, REVENUE_CIRCLE, UPLOAD_FILE_TEXT, INVALID_OTP_ERROR, RESOURCE_ROLES } from "../../../../../common/constants";
import { CommonPincodeMUI } from "../../../../../common/common-pincode/commonPincodeMUI";
import { accountNumberLimit, nameValidation, typeNumberValid, VALIDATION, landAreaValidation, openTextFieldMaxLength, capitalizeFunction, emailValidation, addressMaxLength, govtIDcardLength, approverCommentMaxLength, bankAccountNumber, maxNameLength, contactPersonFirstname, contactPersonMiddlename, contactPersonLastname, totalClumpsMaxLength, mobileNoMaxLength, emailUrnPassMaxLength, lastFourDigit, maxWeightLength } from "../../../../../common/commonValidations";
import { sendOTP, validateOTP } from '../../../../../common/Utils';
import { GENDER, SALUTATION } from '../../../../../common/constants';
import jwt from 'jwt-decode';
import { FileUploadMUI } from "../../../../../common/fileUpload/fileUploadMUI";
import { getLocalStorageItem } from "../../../../../common/localStorageUtils";
import { PROD, LAND_AREA_ERROR } from "../../../../../common/constants";
import BackButton from '../../../../../common/backButton';
import InputAdornment from '@mui/material/InputAdornment';
import { useTranslation } from "react-i18next";
import { DataGrid } from '@mui/x-data-grid';
import { Add as AddIcon } from '@mui/icons-material';
import { v4 as uuidv4 } from 'uuid';
import { insertComment } from '../../commonRegistrationStakeholderAPIs';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { toast } from 'react-toastify';
import { loaderService } from '../../../../../common/custom-loader/loader-service';
import { useGrowerIndividulalContextData } from "../../registrationDetails";
import Badge from 'react-bootstrap/Badge';
import { handleNumberFieldFocus } from "../../../../../common/commonFunction";
import { SaveIcon } from "../../../../../common/icons";
import BadgeComponent from "../../../../../common/badge";
import apiClient from "../../../../../axios";
import CommentIcon from '@mui/icons-material/Comment';




const PersonalDetails = () => {
  const { viewOnly, growerDetails, details, personalDetailsSectionOk, setPersonalDetailsSectionOk, bankDetailsSectionOk, setBankDetailsSectionOk, shouldActOnSection, showCommentSection, setCommentsData, comments, enableFieldFunction, personalUpdatedDetails, setPersonalUpdatedDetails, errorMessage, setErrorMessage, expandedSection, setExpandedSection, regScruResourceUpdate, setRegScruResourceUpdate } = useGrowerIndividulalContextData();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [characterLimit] = useState(300);
  const uuid = localStorage.getItem('uuid');
  const [landAreaValue, setLandAreaValue] = useState('');
  const [landAreaUnit, setLandAreaUnit] = useState(LAND_AREA_UNIT[0]);
  let personalComments = comments?.filter((item) => item.sectionName === "personal_details");
  let bankComments = comments?.filter((item) => item.sectionName === "bank_details");
  // let bambooComments = comments?.filter((item) => item.sectionName === "bamboo_details");
  const [personalComment, setPersonalComment] = useState("");
  const [bankComment, setBankComment] = useState("");
  // const [bambooComment, setBambooComment] = useState("");
  // let regStakeholderMaster = growerDetails?.growers[0]?.regStakeholderMaster;

  const [bankDetails, setBankDetails] = useState();
  const [registrationCompleted, setRegistrationCompleted] = useState(false);
  const [otpValue, setOtpValue] = useState()
  const [mobileOTPValidated, setMobileOTPValidated] = useState(false);
  const [otpHidden, setOtpHidden] = useState(true);
  const [verifyMobileNo, setVerifyMobileNo] = useState(false);
  const decoded = jwt(getLocalStorageItem('id_token'));
  let userRole = localStorage.getItem('role');
  useEffect(() => {
    if (growerDetails) {
      const regStakeholderMaster =
        growerDetails?.growers[0]?.regStakeholderMaster;
      setPersonalUpdatedDetails({
        ...personalUpdatedDetails,
        fullName: regStakeholderMaster?.name,
        contactPersonName: regStakeholderMaster?.contactPersonName,
        contactPersonSalutation: regStakeholderMaster?.contactPersonSalutation,
        contactPersonGender: regStakeholderMaster?.contactPersonGender,
        contactPersonFirstname: regStakeholderMaster?.contactPersonFirstname,
        contactPersonMiddlename: regStakeholderMaster?.contactPersonMiddlename,
        contactPersonLastname: regStakeholderMaster?.contactPersonLastname,
        address: growerDetails?.growers[0]?.address,
        pincode: growerDetails?.growers[0]?.pincode,
        state: growerDetails?.growers[0]?.state,
        district: growerDetails?.growers[0]?.district,
        revenueCircle: growerDetails?.growers[0]?.revenueCircle,
        blockName: growerDetails?.growers[0]?.blockName,
        mobileNo: regStakeholderMaster?.mobileNo,
        emailId: regStakeholderMaster?.emailId,
        otherGovtCardType: regStakeholderMaster?.otherGovtCardType,
        govtIdCardType: regStakeholderMaster?.govtIdCardType ? regStakeholderMaster?.govtIdCardType : "Aadhaar ID",
        govtIdCardNumber: regStakeholderMaster?.govtIdCardNumber,
        panNumber: regStakeholderMaster?.panNumber,
        bankAccountNumber: regStakeholderMaster?.bankAccountNumber,
        bankAccountHolderName: regStakeholderMaster?.bankAccountHolderName,
        bankBranch: regStakeholderMaster?.bankBranch,
        bankIfscCode: regStakeholderMaster?.bankIfscCode,
        bankName: regStakeholderMaster?.bankName,
        growerDocuments: growerDetails?.growers[0]?.growerDocuments,
        plotAddress: growerDetails?.growers[0]?.plotAddress,
        plotPincode: growerDetails?.growers[0]?.plotPincode,
        plotState: growerDetails?.growers[0]?.plotState,
        plotDistrict: growerDetails?.growers[0]?.plotDistrict,
        plotSubDivision: growerDetails?.growers[0]?.plotSubDivision,
        plotRevenueCircle: growerDetails?.growers[0]?.plotRevenueCircle,
        plotBlockName: growerDetails?.growers[0]?.plotBlockName,
        plotPostOffice: growerDetails?.growers[0]?.plotPostOffice,
        plotTotalLandArea: growerDetails?.growers[0]?.plotTotalLandArea,
        plotTotalNoOfBambooClumps: growerDetails?.growers[0]?.plotTotalNoOfBambooClumps,
        growerType: growerDetails?.growers[0]?.growerType,
        isOtpValidated: regStakeholderMaster.isOtpValidated,
        registrationCompleted: growerDetails?.growers[0]?.registrationCompleted,
        registrationStatus: regStakeholderMaster?.registrationStatus,
        aggregationPoint: growerDetails?.growers[0]?.aggregationPoint,
        aggregationPointName: growerDetails?.growers[0]?.aggregationPointName,
        aggregationPointContact: growerDetails?.growers[0]?.aggregationPointContact,
        aggregationPointPincode: growerDetails?.growers[0]?.aggregationPointPincode,
        aggregationPointAddress: growerDetails?.growers[0]?.aggregationPointAddress,
        aggregationPointState: growerDetails?.growers[0]?.aggregationPointState,
        aggregationPointDistrict: growerDetails?.growers[0]?.aggregationPointDistrict,
        aggregationPointSubDivision: growerDetails?.growers[0]?.aggregationPointSubDivision,
        aggregationPointPostOffice: growerDetails?.growers[0]?.aggregationPointPostOffice,
        agreementStartDate: growerDetails?.growers[0]?.agreementStartDate,
        agreementEndDate: growerDetails?.growers[0]?.agreementEndDate,
      });
      const spaceIndex = growerDetails?.growers[0]?.plotTotalLandArea?.indexOf(" ");
      const numberPart = growerDetails?.growers[0]?.plotTotalLandArea?.slice(0, spaceIndex);
      const unitPart = growerDetails?.growers[0]?.plotTotalLandArea?.slice(spaceIndex + 1);
      setLandAreaValue(numberPart);
      setLandAreaUnit(unitPart);
      setMobileOTPValidated(regStakeholderMaster.isOtpValidated);
    }

  }, [growerDetails]);

  const getUpdatedAddressData = (data) => {
    setPersonalUpdatedDetails({
      ...personalUpdatedDetails,
      pincode: data.pincode,
      state: data.pincodeState,
      district: data.pincodeDistrict,
      subDivision: data.pincodeSubDivision,
      revenueCircle: data.selectedRevenueCircle,
      blockName: data.selectedBlockName,

    })
  }
  const handleChangeSelect = (e, type) => {
    if (type == BLOCK_LIST) {
      setPersonalUpdatedDetails({ ...personalUpdatedDetails, blockName: e.target.value });
    }
    if (type == REVENUE_CIRCLE) {
      setPersonalUpdatedDetails({ ...personalUpdatedDetails, revenueCircle: e.target.value, });
    }
  }
  const handleBambooChangeSelect = (e, type) => {
    if (type == BLOCK_LIST) {
      setPersonalUpdatedDetails({ ...personalUpdatedDetails, plotBlockName: e.target.value });
    }
    if (type == REVENUE_CIRCLE) {
      setPersonalUpdatedDetails({ ...personalUpdatedDetails, plotRevenueCircle: e.target.value, });
    }
  }
  const getBambooUpdatedAddressData = (data) => {
    setPersonalUpdatedDetails({
      ...personalUpdatedDetails,
      plotPincode: data.pincode,
      plotState: data.pincodeState,
      plotDistrict: data.pincodeDistrict,
      plotSubDivision: data.pincodeSubDivision,
      plotRevenueCircle: data.selectedRevenueCircle,
      plotBlockName: data.selectedBlockName,

    })
  }
  useEffect(() => {
    if (bankDetails) {
      setPersonalUpdatedDetails({
        ...personalUpdatedDetails, bankBranch: bankDetails?.branch, bankName: bankDetails?.bank
      });
    }
  }, [bankDetails]);

  const onClickVerifyMobileNo = (e) => {
    e.preventDefault();
    setErrorMessage({ ...errorMessage, OTPError: "" });
    setOtpValue("");
    if (personalUpdatedDetails.mobileNo) {
      sendOTP(personalUpdatedDetails.mobileNo, callBackMobileValidation);
    }
  }
  const callBackMobileValidation = (response) => {
    if (response.isSuccess) {
      setVerifyMobileNo(true);
      setOtpHidden(false);
      setErrorMessage({ ...errorMessage, OTPError: "" });
    }
  }
  const onOtpChange = (e) => {
    const limit = 6;
    setOtpValue(e.target.value.slice(0, limit))
    if (e.target.value.length == 6) {
      validateOTP(personalUpdatedDetails.mobileNo, e.target.value, callBackOTPValidation);
    }
  }
  const callBackOTPValidation = (response) => {
    if (response.isSuccess) {
      setVerifyMobileNo(false);
      setOtpHidden(true);
      setMobileOTPValidated(true);
      setPersonalUpdatedDetails({ ...personalUpdatedDetails, isOtpValidated: true })
      setErrorMessage({ ...errorMessage, OTPError: "" });
    }
    else {
      setErrorMessage({ ...errorMessage, OTPError: INVALID_OTP_ERROR });
    }
  }
  const onUploadCallBack = (docArray) => {

    setPersonalUpdatedDetails({ ...personalUpdatedDetails, growerDocuments: docArray });
  }
  function getBankDetails() {
    loaderService.showLoader();
    apiClient
      .post(GET_ADDRESS_BY_IFSC,
        {
          "ifsc": personalUpdatedDetails?.bankIfscCode,
        },
        {
          headers: {
            AuthKey: authKey,
          },
        }
      )
      .then((response) => {
        loaderService.hideLoader();
        if (response.data.isSuccess === true) {
          setBankDetails(response.data);
          setErrorMessage({ ...errorMessage, ifscCodeError: "" });
        }
        else {
          setPersonalUpdatedDetails({
            ...personalUpdatedDetails,
            bankIfscCode: "",
            bankBranch: '',
          })
        }
      })
      .catch(function (error) {
        loaderService.hideLoader();
        console.log(error);
      });
  }
  const handleChange = (e) => {
    setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: (e.target.value) })
    if (e.target.name === "contactPersonFirstname") {
      setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: nameValidation(e.target.value.slice(0, 50)) })
      if ((e.target.value).length > 0 && nameValidation(e.target.value)) {
        setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: nameValidation(e.target.value.slice(0, 50)) })
        setErrorMessage({ ...errorMessage, contactPersonFirstNameError: '' })
      } else setErrorMessage({ ...errorMessage, contactPersonFirstNameError: "Please Enter Valid Name" })
    }
    if (e.target.name === "contactPersonMiddlename") {
      setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: nameValidation(e.target.value.slice(0, 50)) })
      if ((e.target.value).length > 0) {
        setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: nameValidation(e.target.value.slice(0, 50)) })
      } else return
    }
    else if (e.target.name === "contactPersonLastname") {
      setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: nameValidation(e.target.value.slice(0, 50)) })
      if ((e.target.value).length > 0) {
        setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: nameValidation(e.target.value.slice(0, 50)) })
      } else return
    }
    else if (e.target.name === 'emailId') {
      setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: e.target.value.slice(0, 50) })
      if ((e.target.value).length > 0) {
        if (emailValidation(e.target.value.slice(0, 50))) {
          setErrorMessage({ ...errorMessage, emailIdError: "" })
        } else setErrorMessage({ ...errorMessage, emailIdError: "Please enter valid Email Address" })
      }
      else setErrorMessage({ ...errorMessage, emailIdError: "" })
    }
    else if (e.target.name === "address") {
      setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 200)) });
      if ((e.target.value).length > 0 && VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 200))) {
        setErrorMessage({ ...errorMessage, addressError: "" })
      } else {
        setErrorMessage({ ...errorMessage, addressError: "Please enter address" })

      }
    }
    else if (e.target.name === "bankAccountNumber") {
      const limit = 18;
      if (e.target.value.length > 0 && VALIDATION.bankAccountNumberValidation(e.target.value.slice(0, limit))) {
        setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: e.target.value.slice(0, limit) })
        setErrorMessage({ ...errorMessage, accountNumberError: '' })

      } else setErrorMessage({ ...errorMessage, accountNumberError: 'Please enter valid Account Number' })
    }
    else if (e.target.name === "bankAccountHolderName") {
      setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: VALIDATION.fullNameValidation(e.target.value) })
      if (e.target.value.length > 0 && VALIDATION.fullNameValidation(e.target.value)) {
        setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: VALIDATION.fullNameValidation(e.target.value) })
        setErrorMessage({ ...errorMessage, accountHolderNameError: '' })
      } else setErrorMessage({ ...errorMessage, accountHolderNameError: "Please enter Account Holder's Name" })
    }
    if (e.target.name === 'panNumber') {
      setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: (e.target.value.toUpperCase()) })
      if (e.target.value.length > 0 && VALIDATION.panNumberValidation(e.target.value.toUpperCase())) {
        setErrorMessage({ ...errorMessage, panNumberError: "" })
        setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: e.target.value.toUpperCase().replace(/[^A-Z0-9]/gi, '') });
      } else setErrorMessage({ ...errorMessage, panNumberError: "Please enter valid PAN Number" })
    }
    if (e.target.name === 'govtIdCardNumber') {
      const limit = 4;
      if (e.target.value.length > 0) {
        setErrorMessage({ ...errorMessage, govtIdCardNumberError: '' })
        if (personalUpdatedDetails.govtIdCardType === "Aadhaar ID") {
          setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: e.target.value.replace(/[^0-9]/gi, '').slice(0, limit) });
        }
        else {
          setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: e.target.value.toUpperCase().slice(0, 20) });
        }
      } else setErrorMessage({ ...errorMessage, govtIdCardNumberError: 'Please enter ID Number' })
    }
    if (e.target.name === 'bankIfscCode') {
      if (e.target.value.length > 0 && VALIDATION.ifscValidation(e.target.value.toUpperCase())) {
        setErrorMessage({ ...errorMessage, ifscCodeError: "" })
        setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: e.target.value.toUpperCase().replace(/[^A-Z0-9]/gi, ''), bankBranch: "" });
      } else setErrorMessage({ ...errorMessage, ifscCodeError: "Please enter valid IFSC Code" })
    }
    if (e.target.name === "landAreaValue") {
      var slicedLandArea = landAreaValidation(e.target.value);
      setLandAreaValue(slicedLandArea);
      if (slicedLandArea.length == 0) {
        setErrorMessage({ ...errorMessage, plotTotalLandAreaError: LAND_AREA_ERROR });
      }
      else setErrorMessage({ ...errorMessage, plotTotalLandAreaError: "" });
      setPersonalUpdatedDetails({ ...personalUpdatedDetails, "plotTotalLandArea": slicedLandArea + ' ' + landAreaUnit });
    }
    if (e.target.name === "landAreaUnit") {
      setLandAreaUnit(e.target.value);
      setPersonalUpdatedDetails({ ...personalUpdatedDetails, "plotTotalLandArea": landAreaValue + ' ' + e.target.value });
    }
  };

  const commentsColumn = [
    {
      field: 'comment', headerName: t('reg.comments'), width: 330,
      renderCell: (params) => {
        return (
          <div style={{ wordBreak: "break-all", overflowWrap: "break-word", whiteSpace: "normal", minHeight: "auto" }}>
            {params.value.split('<br />').map((line, index) => (
              <>
                {line}
                <br />
              </>
            ))}
          </div>
        )
      }
    },
    {
      field: 'createdByName', headerName: t('preReg.name'), width: 200
    },
    {
      field: 'userRole', headerName: t('reg.userRole'), width: 200
    },
    {
      field: 'createdOnFormatted', headerName: t('reg.date'), width: 200,
    },
  ]

  const onSaveComment = (comment, sectionName, sectionOk) => {
    const commentObject = {
      comment: comment,
      stakeholderMasterId: growerDetails?.growers[0]?.regStakeholderMasterId,
      sectionName: sectionName,
      sectionId: growerDetails?.growers[0]?.id,
      sectionOk: sectionOk,
      userRole: localStorage.getItem('role'),
      createdBy: decoded.extension_URN ? growerDetails?.growers[0]?.regStakeholderMasterId : uuid,
    }
    comment ? insertComment([commentObject], growerDetails?.growers[0]?.regStakeholderMasterId, setCommentsData) : toast.error("Please enter comment")
    setPersonalComment("");
    setBankComment("");
    // setBambooComment("");
    setErrorMessage({ ...errorMessage, personalCommentError: "", bankCommentError: "" });
  }

  return (
    <>
      {personalUpdatedDetails && <>
        <Grid item xs={12}>
          <Accordion mt={1} expanded={expandedSection === "personal"}
            onChange={(event, expanded) => {
              setExpandedSection(expanded ? "personal" : "");
            }}>
            <AccordionSummary 
sx={{
    flexDirection: 'row-reverse',
    backgroundColor:
      showCommentSection && !regScruResourceUpdate
        ? (personalDetailsSectionOk ? "#E9FBF0" : "#FFEBEE")
        : "#FFFFFF"
  }}

              expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
            >
              <Stack ml={2} display="flex" alignItems="center" direction="row">

{showCommentSection && !regScruResourceUpdate && (
  personalDetailsSectionOk ? 
    <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} /> 
  : 
    <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginRight: "1vh" }} />
)}
                <Typography variant="subtitle1">{t('preReg.personalDetails')}</Typography>
              </Stack>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container pr={4} pb={3} spacing={2} 
sx={{
    backgroundColor:
      showCommentSection && !regScruResourceUpdate
        ? (personalDetailsSectionOk ? "#E9FBF0" : "#FFEBEE")
        : "#FFFFFF",
    width: "103.5%"
  }}
>
                {personalUpdatedDetails.growerType === "Other Agency" &&
                  <Grid item xs={4} lg={12}>
                    <TextField
                      required
                      disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                      type="text"
                      name="Name"
                      label="Name of Office"
                      value={personalUpdatedDetails.fullName || ''}
                      onChange={(e) => handleChange(e)}
                      inputProps={{
                        maxLength: 50

                      }}
                    />
                  </Grid>}
                <Grid item xs={4} lg={2}>
                  <FormControl fullWidth>
                    <InputLabel>{t('preReg.salutation')}</InputLabel>
                    <Select
                      label={t('preReg.salutation')}
                      disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                      name='contactPersonSalutation'
                      onChange={(e) => handleChange(e)} value={personalUpdatedDetails.contactPersonSalutation}>
                      {SALUTATION.map((item) => <MenuItem value={item}>{item}</MenuItem>)}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={8} lg={4}>
                  <TextField fullWidth
                    required
                    error={errorMessage.contactPersonFirstNameError}
                    helperText={errorMessage.contactPersonFirstNameError}
                    label={t('preReg.firstname')}
                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                    type="text"
                    name="contactPersonFirstname"
                    placeholder="First Name"
                    value={personalUpdatedDetails.contactPersonFirstname}
                    onChange={(e) => handleChange(e)}
                    inputProps={{
                      maxLength: 50,

                    }}
                  />
                  <BadgeComponent currentLength={personalUpdatedDetails?.contactPersonFirstname?.length} maxLength={maxNameLength} />
                </Grid>
                <Grid item xs={6} lg={3}>
                  <TextField fullWidth
                    type="text"
                    error={errorMessage.contactPersonMiddlenameError}
                    helperText={errorMessage.contactPersonMiddlenameError}
                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                    value={personalUpdatedDetails.contactPersonMiddlename}
                    name="contactPersonMiddlename"
                    label={t('preReg.middlename')}
                    onChange={(e) => handleChange(e)}
                    inputProps={{
                      maxLength: 50,

                    }} />
                    <BadgeComponent currentLength={personalUpdatedDetails?.contactPersonMiddlename?.length} maxLength={maxNameLength} />
                </Grid>
                <Grid item xs={6} lg={3}>
                  <TextField fullWidth
                    type="text"
                    error={errorMessage.contactPersonLastnameError}
                    helperText={errorMessage.contactPersonLastnameError}
                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                    value={personalUpdatedDetails.contactPersonLastname}
                    name="contactPersonLastname"
                    label={t('preReg.lastname')}
                    onChange={(e) => handleChange(e)}
                    inputProps={{
                      maxLength: 50,

                    }} />
                    <BadgeComponent currentLength={personalUpdatedDetails?.contactPersonLastname?.length} maxLength={maxNameLength} />
                </Grid>
                <Grid item xs={4} lg={2}>
                  <FormControl fullWidth error={errorMessage?.genderError}>
                    <InputLabel>{t('preReg.gender')}</InputLabel>
                    <Select
                      label={t('preReg.gender')}
                      name='contactPersonGender'
                      disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                      value={personalUpdatedDetails.contactPersonGender}
                      onChange={(e) => handleChange(e)}
                    >

                      {GENDER.map((item) => <MenuItem value={item}>{item}</MenuItem>)}
                    </Select>
                    <FormHelperText sx={{ color: 'red' }}>{errorMessage?.genderError}</FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={8} lg={4}>
                  <TextField fullWidth
                    required
                    error={errorMessage.mobileNoError}
                    helperText={errorMessage.mobileNoError}
                    type="number"
                    onFocus={handleNumberFieldFocus}
                    label={t('preReg.mobileNo')}
                    InputProps={{
                      maxLength: 10
                    }}
                    name="mobileNo"
                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                    value={personalUpdatedDetails?.mobileNo}
                    onChange={(e) => handleChange(e)} />
                    <BadgeComponent currentLength={personalUpdatedDetails?.mobileNo?.length} maxLength={mobileNoMaxLength} />
                  {!ResourceUpdateMember.includes(userRole) &&
                    mobileOTPValidated ?
                    <div className="commonVerifyText"><a href="#">Verified</a>
                      <img className="commonOtpImg" src={resolveIcon} alt="" /></div>
                    :
                    <div hidden={mobileOTPValidated || verifyMobileNo} style={{ float: "right" }}><button className="commonVerifyText" onClick={(e) => onClickVerifyMobileNo(e)}>Verify Mobile No.</button>
                      <div className='errorText_storage'>{errorMessage.OTPError}</div> <div hidden={otpHidden}><button className="commonVerifyText" onClick={(e) => onClickVerifyMobileNo(e)}>Resend OTP</button></div></div>
                  }
                </Grid>
                <Grid item xs={3} lg={2} hidden={otpHidden}>
                  <TextField fullWidth
                    type="number"
                    onFocus={handleNumberFieldFocus}
                    onChange={(e) => onOtpChange(e)}
                    value={otpValue}
                    label={t('preReg.otp')} />
                </Grid>
                <Grid item xs={12} lg={6}>
                  <TextField fullWidth
                    error={errorMessage.emailIdError}
                    helperText={errorMessage.emailIdError}
                    type="text"
                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                    label={t('main.email')}
                    name="emailId"
                    value={personalUpdatedDetails.emailId}
                    onChange={(e) => handleChange(e)} />
                     <BadgeComponent currentLength={personalUpdatedDetails?.emailId?.length} maxLength={emailUrnPassMaxLength} />
                </Grid>
                <Grid item xs={12} lg={12}>
                  <TextField fullWidth
                    error={errorMessage?.addressError}
                    helperText={errorMessage?.addressError}
                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                    type="text"
                    name="address"
                    label={t('main.address')}
                    value={personalUpdatedDetails.address}
                    onChange={(e) => handleChange(e)}
                    inputProps={{
                      maxLength: addressMaxLength,

                    }}
                  />
                  <BadgeComponent currentLength={personalUpdatedDetails?.address?.length} maxLength={addressMaxLength} />
                </Grid>
                <CommonPincodeMUI setErrorMessage={setErrorMessage}
                  fullWidth={true}
                  isDisabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                  pincode={personalUpdatedDetails.pincode}
                  state={personalUpdatedDetails.state}
                  district={personalUpdatedDetails.district}
                  revenueCircle={personalUpdatedDetails.revenueCircle}
                  blockName={personalUpdatedDetails.blockName}
                  onHandleCallback={getUpdatedAddressData}
                  pincodeError={errorMessage.pincodeError}
                  searchError={errorMessage.searchError}
                  handleChangeSelect={handleChangeSelect}
                />
                <Grid item xs={12} lg={4}>
                  <TextField fullWidth
                    required
                    error={errorMessage.panNumberError}
                    helperText={errorMessage.panNumberError}
                    type="text"
                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                    label={t('reg.panNumber')}
                    name="panNumber"
                    value={personalUpdatedDetails?.panNumber}
                    onChange={(e) => handleChange(e)}
                    inputProps={{
                      maxLength: 10,
                      style: { textTransform: "uppercase" }
                    }}
                  />
                  <BadgeComponent currentLength={personalUpdatedDetails?.panNumber?.length} maxLength={10} />
                  <FileUploadMUI key="PANCard"
                    documentList={personalUpdatedDetails?.growerDocuments}
                    documentType="PANCard"
                    callBackDocumentUpload={onUploadCallBack}
                    stakeholderDetailId={growerDetails?.growers[0]?.id}
                    title={t('preReg.uploadPanDoc')}
                    stakeHolderType="grower"
                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                    errorMessage={errorMessage}
                    setErrorMessage={setErrorMessage}
                    documentError="panDocError"
                  />
                  {/* <div className='mandatory_field'>{errorMessage.panDocError}</div> */}
                </Grid>
                <Grid item xs={12} lg={4}>
                  <FormControl fullWidth>
                    <InputLabel>{t('preReg.addressProof')}</InputLabel>
                    <Select
                      label={t('preReg.addressProof')}
                      disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                      name="govtIdCardType"
                      value={personalUpdatedDetails.govtIdCardType}
                      onChange={(e) => handleChange(e)} >
                      {CONSTANTS.GOV_ID_LIST.map((item) => <MenuItem value={item}>{item}</MenuItem>)}
                    </Select>
                  </FormControl>
                  <FileUploadMUI key="IDProof"
                    documentList={personalUpdatedDetails?.growerDocuments}
                    documentType="IDProof"
                    callBackDocumentUpload={onUploadCallBack}
                    stakeholderDetailId={growerDetails?.growers[0]?.id}
                    title={t('reg.uploadIDProofDoc')}
                    stakeHolderType="grower"
                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                    errorMessage={errorMessage}
                    setErrorMessage={setErrorMessage}
                    documentError="idProofDocError"
                  />
                  {/* <div className='mandatory_field'>{errorMessage.idProofDocError}</div> */}
                </Grid>
                <Grid item xs={12} lg={4}>
                  <TextField fullWidth
                    required
                    error={errorMessage.govtIdCardNumberError}
                    helperText={errorMessage.govtIdCardNumberError}
                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                    type="text"
                    name="govtIdCardNumber"
                    label={personalUpdatedDetails.govtIdCardType === "Aadhaar ID" ? t('preReg.enterLast4digit') : personalUpdatedDetails.govtIdCardType === "Voter ID" ? t('preReg.enterVoterId') : personalUpdatedDetails.govtIdCardType === "Driving Licence" ? t('preReg.enterDrivinglicense') : t('preReg.enterBankPassbookNo')}
                    value={personalUpdatedDetails.govtIdCardNumber}
                    onChange={(e) => handleChange(e)}
                    InputProps={{
                      style: { textTransform: "uppercase" }
                    }} />
                    <BadgeComponent currentLength={personalUpdatedDetails?.govtIdCardNumber?.length} maxLength={lastFourDigit} />
                </Grid>
              </Grid>
              {showCommentSection && <><Grid container direction="row" mt={2} mb={2} alignItems="center" spacing={2}>
                <Grid item xs={6} lg={7}>
                  <TextField sx={{ width: "100%" }}
                    label={t('reg.comment')}
                    helperText={errorMessage.personalCommentError}
                    error={errorMessage.personalCommentError}
                    name="comment"
                    inputProps={{
                      maxLength: approverCommentMaxLength,
                    }}
                    multiline
                    disabled={!shouldActOnSection.personal_details || viewOnly}
                    value={personalComment}
                    onChange={(e) => setPersonalComment(VALIDATION.noSpecialCharacterValidation(e.target.value))}
                  />
                  <BadgeComponent currentLength={personalComment?.length} maxLength={approverCommentMaxLength} />
                  {/* <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                    <Badge bg={`${personalComment?.length > characterLimit ? 'danger' : 'primary'}`}>{personalComment?.length}/{characterLimit}</Badge>
                  </div> */}
                </Grid>
                <Grid item xs={4} lg={2}>
                  <FormGroup>
                    <FormControlLabel control={<Switch disabled={!shouldActOnSection.personal_details || viewOnly} checked={personalDetailsSectionOk}
                      onChange={(e) => setPersonalDetailsSectionOk(e.target.checked)} />} label={<Typography variant="subtitle2">
                        {t('reg.detailsOk')}?
                      </Typography>} />
                  </FormGroup>
                </Grid>
                <Grid item xs={3}>
                  <Button variant="contained" disabled={!shouldActOnSection.personal_details || viewOnly}
                    onClick={() => onSaveComment(personalComment, "personal_details", personalDetailsSectionOk)}
                    startIcon={<CommentIcon />}
                  >
                    {t('preReg.addComment')}
                  </Button>
                </Grid>
              </Grid>
                <div>
                  <Accordion mt={1} >
                    <AccordionSummary
                      expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                    >
                      <Typography variant="subtitle1" ml={2}>{t('reg.commentHistory')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Box style={{ height: 300, width: '100%' }}>
                        <DataGrid
                          rows={personalComments ? personalComments : []}
                          columns={commentsColumn}
                          pageSize={10}
                          getRowHeight={() => 'auto'} />
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                </div></>}
            </AccordionDetails>

          </Accordion>
        </Grid>
        <Grid item xs={12}>
          <Accordion mt={1} expanded={expandedSection === "bank"}
            onChange={(event, expanded) => {
              setExpandedSection(expanded ? "bank" : "");
            }}>
            <AccordionSummary sx={{ flexDirection: 'row-reverse', backgroundColor: showCommentSection && !regScruResourceUpdate ? (bankDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF" }}
              expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
            >
              <Stack ml={2} display="flex" alignItems="center" direction="row">
                {showCommentSection && !regScruResourceUpdate && (bankDetailsSectionOk ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginRight: "1vh" }} />)}
                <Typography variant="subtitle1">{t('preReg.bankDetails')}</Typography>
              </Stack>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container pb={3} pr={4} spacing={2} sx={{ backgroundColor: showCommentSection && !regScruResourceUpdate ? (bankDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF", width: "103.5%" }}>
                <Grid item xs={12} lg={4}>
                  <TextField fullWidth
                    required
                    error={errorMessage.accountNumberError}
                    helperText={errorMessage.accountNumberError}
                    disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)}
                    type="number"
                    onFocus={handleNumberFieldFocus}
                    name="bankAccountNumber"
                    label={t('preReg.accountNo')}
                    InputProps={{
                      style: { textTransform: "uppercase" }
                    }}
                    value={personalUpdatedDetails.bankAccountNumber}
                    onChange={(e) => handleChange(e)}
                    onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                  />
                  <BadgeComponent currentLength={personalUpdatedDetails?.bankAccountNumber?.length} maxLength={bankAccountNumber} />
                </Grid>
                <Grid item xs={12} lg={4}>
                  <TextField fullWidth
                    required
                    error={errorMessage.accountHolderNameError}
                    helperText={errorMessage.accountHolderNameError}
                    disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)}
                    type="text"
                    name="bankAccountHolderName"
                    label={t('preReg.accountHolderName')}
                    value={personalUpdatedDetails.bankAccountHolderName}
                    onChange={(e) => handleChange(e)}
                    InputProps={{
                        maxLength: maxNameLength,

                    }}
                  />
                  <BadgeComponent currentLength={personalUpdatedDetails?.bankAccountHolderName?.length} maxLength={maxNameLength} />
                </Grid>
                <Grid item xs={12} lg={4}>
                  <TextField fullWidth
                    required
                    error={errorMessage.ifscCodeError}
                    helperText={errorMessage.ifscCodeError}
                    disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)}
                    type="text"
                    name="bankIfscCode"
                    label={t('preReg.ifscCode')}
                    value={personalUpdatedDetails.bankIfscCode}
                    onChange={(e) => handleChange(e)}
                    onKeyDown={(evt) => (evt.key === '.' || evt.key === '-') && evt.preventDefault()}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {(!ResourceUpdateMember.includes(userRole) || userRole === 'Reg-ITAdmin') ? <IconButton color="primary" aria-label="search" onClick={() => getBankDetails()} disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)} >
                            <SearchIcon />
                          </IconButton> : <IconButton color="primary" aria-label="search" onClick={() => getBankDetails()} disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)} >
                          </IconButton>}
                        </InputAdornment>
                      ),
                      maxLength: 11,
                      style: { textTransform: "uppercase" }
                    }}
                  ></TextField>
                </Grid>
                <Grid item xs={12} lg={5}>
                  <TextField fullWidth
                    disabled
                    type="text"
                    name="bankBranch"
                    label={t('preReg.branch')}
                    value={personalUpdatedDetails.bankBranch || ''}
                    onChange={(e) => handleChange(e)}
                  />
                  <FileUploadMUI key="BankPassBook_CancelledCheque"
                    documentList={personalUpdatedDetails?.growerDocuments}
                    documentType="BankPassBook_CancelledCheque"
                    callBackDocumentUpload={onUploadCallBack}
                    stakeholderDetailId={growerDetails?.growers[0]?.id}
                    title={t('preReg.uploadPassbookCancelledCheck')}
                    stakeHolderType="grower"
                    disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)}
                    errorMessage={errorMessage}
                    setErrorMessage={setErrorMessage}
                    documentError="bankDocError"
                  />
                  {/* <div className='mandatory_field'>{errorMessage.bankDocError}</div> */}
                </Grid>
              </Grid>
              {showCommentSection && <>
                <Grid container direction="row" mt={2} mb={2} alignItems="center" spacing={2}>
                  <Grid item xs={6} lg={7}>
                    <TextField sx={{ width: "100%" }}
                      label={t('reg.comment')}
                      name="comment"
                      helperText={errorMessage.bankCommentError}
                      error={errorMessage.bankCommentError}
                      inputProps={{
                        maxLength: 300,
                      }}
                      multiline
                      value={bankComment}
                      disabled={!shouldActOnSection.bank_details || viewOnly}
                      onChange={(e) => setBankComment(VALIDATION.noSpecialCharacterValidation(e.target.value))}
                    />
                    {/* <BadgeComponent currentLength={bankComment?.plotComment?.length} maxLength={approverCommentMaxLength} /> */}
                    <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                      <Badge bg={`${bankComment?.length > characterLimit ? 'danger' : 'primary'}`}>{bankComment?.length}/{characterLimit}</Badge>
                    </div>
                  </Grid>
                  <Grid item xs={4} lg={2}>
                    <FormGroup>
                      <FormControlLabel control={<Switch disabled={!shouldActOnSection.bank_details || viewOnly} checked={bankDetailsSectionOk}
                        onChange={(e) => setBankDetailsSectionOk(e.target.checked)} />} label={<Typography variant="subtitle2" gutterBottom>
                          {t('reg.detailsOk')}?
                        </Typography>} />
                    </FormGroup>
                  </Grid>
                  <Grid item xs={3}>
                    <Button variant="contained" disabled={!shouldActOnSection.bank_details || viewOnly}
                      onClick={() => onSaveComment(bankComment, "bank_details", bankDetailsSectionOk)}
                      startIcon={<CommentIcon />}
                    >
                      {t('preReg.addComment')}
                    </Button>
                  </Grid>
                </Grid>
                <div>
                  <Accordion mt={1}>
                    <AccordionSummary
                      expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                    >
                      <Typography variant="subtitle1" ml={2}>{t('reg.commentHistory')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Box style={{ height: 300, width: '100%' }}>
                        <DataGrid
                          rows={bankComments ? bankComments : []}
                          columns={commentsColumn}
                          pageSize={10}
                          getRowHeight={() => 'auto'} />
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                </div>
              </>}
            </AccordionDetails>

          </Accordion>
        </Grid>
        <Grid item xs={12}>
          <Accordion mt={1} expanded={expandedSection === "bamboo"}
            onChange={(event, expanded) => {
              setExpandedSection(expanded ? "bamboo" : "");
            }}>
            <AccordionSummary sx={{ flexDirection: 'row-reverse', backgroundColor: showCommentSection && !regScruResourceUpdate ? "#E9FBF0" : "FFFFFF" }}
              expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
            >
              <Stack ml={2} display="flex" alignItems="center" direction="row">
                {showCommentSection && !regScruResourceUpdate && <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} />}
                <Typography variant="subtitle1">{t('preReg.bambooDetails')}</Typography>
              </Stack>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container pb={3} pr={4} spacing={2} sx={{ backgroundColor: showCommentSection && !regScruResourceUpdate ? "#E9FBF0" : "FFFFFF", width: "103.5%" }}>
                <Grid item xs={12} lg={3}>
                  <TextField fullWidth
                    disabled={!enableFieldFunction(false, true)}
                    type="number"
                    onFocus={handleNumberFieldFocus}
                    label={t('preReg.totalPlotArea')}
                    min="0"
                    name="landAreaValue"
                    value={landAreaValue}
                    onKeyDown={(evt) => typeNumberValid(evt)} onChange={(e) => handleChange(e)}
                    InputProps={{
                      endAdornment: (
                        <Select
                          variant="standard"
                          size="small"
                          disabled={!enableFieldFunction(false, true)}
                          value={landAreaUnit}
                          name="landAreaUnit"
                          onChange={(e) => handleChange(e)}>
                          {LAND_AREA_UNIT.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
                        </Select>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} lg={3}>
                  <TextField fullWidth
                    disabled={!enableFieldFunction(false, true)}
                    value={personalUpdatedDetails.plotTotalNoOfBambooClumps || ''}
                    name="plotTotalNoOfBambooClumps"
                    type="number"
                    onFocus={handleNumberFieldFocus}
                    label={t('preReg.totalClumps')}
                    onKeyDown={(evt) => typeNumberValid(evt)}
                    onChange={(e) => handleChange(e)} />
                    <BadgeComponent currentLength={personalUpdatedDetails?.plotTotalNoOfBambooClumps?.length} maxLength={totalClumpsMaxLength} />
                </Grid>
                <Grid item xs={12} lg={6}>
                  <TextField fullWidth
                    disabled={!enableFieldFunction(false, true)}
                    type="text"
                    label={t('preReg.plotAddress')}
                    multiline
                    name="plotAddress"
                    value={personalUpdatedDetails.plotAddress || ''}
                    onChange={(e) => handleChange(e)} />
                    <BadgeComponent currentLength={personalUpdatedDetails?.plotAddress?.length} maxLength={addressMaxLength} />
                </Grid>
                <CommonPincodeMUI setErrorMessage={setErrorMessage}
                  fullWidth={true}
                  pincode={personalUpdatedDetails.plotPincode}
                  state={personalUpdatedDetails.plotState}
                  district={personalUpdatedDetails.plotDistrict}
                  revenueCircle={personalUpdatedDetails.plotRevenueCircle}
                  blockName={personalUpdatedDetails.plotBlockName}
                  isDisabled={!enableFieldFunction(false, true)}
                  onHandleCallback={getBambooUpdatedAddressData}
                  handleChangeSelect={handleBambooChangeSelect} />
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Grid> </>}
    </>
  );
};

export default PersonalDetails;
